import { PAYMENTS_TYPES } from "./paymentsTypes";

const {
  LOAD_PAYMENTS,
  CLEAR_PAYMENTS,
  SET_ACCOUNTS,
  SET_PAYMENTS,
  SET_SELECTED_ACCOUNT,
  HANDLE_PAYMENTS_INPUTS,
} = PAYMENTS_TYPES;

const initialState = {
  isLoadingPage: false,
  payments: [],
  accounts: [],
  accountSelected: null,
  station: null,
  config: {
    pageSize: 10,
    page: 0,
    sorted: [],
    filtered: []
  }
};

export const paymentsReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case HANDLE_PAYMENTS_INPUTS:
      return {
        ...state,
        [payload.key]: payload.value
      };
    case LOAD_PAYMENTS:
      return {
        ...state,
        isLoadingPage: true
      };

    case SET_PAYMENTS:
      return {
        ...state,
        isLoadingPage: false,
        payments: payload.payments
      };

    case SET_ACCOUNTS:
      return {
        ...state,
        isLoadingPage: false,
        accounts: payload.accounts
      };

    case SET_SELECTED_ACCOUNT:
      return {
        ...state,
        accountSelected: payload
      };

    case CLEAR_PAYMENTS:
      return {
        ...state,
        ...initialState
      };

    default:
      return state;
  }
};
